<template>
	<div id="app">
		<Header v-if="!request_error"></Header>
		<keep-alive>
			<router-view v-if="$route.meta.keepAlive && !request_error" />
		</keep-alive>
		<router-view v-if="!$route.meta.keepAlive && !request_error" />
		<Login v-if="show_login"></Login>
		<Teamlogin v-if="show_team_login"></Teamlogin>
		<Error v-if="request_error"></Error>
	</div>
</template>

<script>
	import Header from '@/common/components/header'
	import Login from '@/common/components/login'
	import Teamlogin from '@/common/components/teamLogin'
	import Error from '@/common/components/error'
	export default {
		computed: {
			show_login() {
				return this.$store.state.show_login
			},
			show_team_login() {
				return this.$store.state.show_team_login
			},
			request_error() {
				return this.$store.state.request_error
			}
		},
		components: {
			Header,
			Login,
			Teamlogin,
			Error
		}
	}
</script>

<style>
	.page-box {
		width: 1200px;
		margin: 0 auto;
	}
</style>


// WEBPACK FOOTER //
// src/App.vue